import React, { useContext, useEffect, useState } from 'react'
import { ScoreCardContext } from '../../store/scorecard-context'
import { getCookie } from '../../utils/common'
// import Questions from './Questions'
import styles from './Styles.module.css'
// import { isAllQuestionAnswered } from './common'
import { AuthContext } from '../../store/auth-context'
import { customerEffortAssessmentAPI } from '../../services/api/customer-effort-assessment'
import Questions from './Questions'


const CustomeEffortAssesment = (props: any) => {

    const scorecardCtx = useContext(ScoreCardContext)
    
    const [isContextLoaded, setIsContextLoaded] = useState<boolean>(false)

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isSubmittingError, setIsSubmittingError] = useState(false)
    const [isSubmittingSuccess, setIsSubmittingSuccess] = useState(false)

    useEffect(() => {
        if(scorecardCtx?.customerEffortAssesment?.sections && scorecardCtx?.customerEffortAssesment?.sections.length) {
            setIsContextLoaded(true)
        }
    }, [scorecardCtx.customerEffortAssesment])    

    const submitReview = () => {
        setIsSubmittingError(false)
        setIsSubmittingSuccess(false)
        setIsSubmitting(true)
        let tenantSlug = getCookie('current_tenant')
        const data = scorecardCtx.customerEffortAssesment
        customerEffortAssessmentAPI(tenantSlug)?.put?.(props.id, data)
        .then((response: any) => {
            setIsSubmittingSuccess(true)
            setIsSubmitting(false)
            // getReviewStats()
            setTimeout(() => {
                setIsSubmittingSuccess(false)
            }, 3000)
        })
        .catch((err: any) => {
            setIsSubmittingError(true)
            setIsSubmitting(false)
            setTimeout(() => {
                setIsSubmittingError(false)
            }, 3000)
            if (err.response) {
                console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log(err)
            }
        })
        
        window.scrollTo(0, 0)
    }

    return (
        <div className={styles.scoreCardContainer}>
            <div className={`d-flex justify-content-between mb-2 ${styles.scoreCardHeader}`}>
                {
                    isContextLoaded ?
                        <>
                            <h6>Customer Effort Assessment</h6> 
                            <div className={styles.submitReviewContainer}>
                                {
                                    isSubmitting ?
                                    <div>
                                        <div className="alert alert-primary d-flex align-items-center fw-bold" role="alert">
                                            <span className="spinner-border spinner-border-sm pe-1 me-2" role="status" aria-hidden="true"></span>Submitting...
                                        </div>
                                    </div>
                                    :
                                    (
                                        isSubmittingError ?
                                            <div className="alert alert-danger d-flex align-items-center fs-6" role="alert">
                                                <i className="bi bi-exclamation-triangle pe-1"></i>
                                                <div>
                                                    Opps Somthing went wrong! Please try again.
                                                </div>
                                            </div>
                                            :
                                            (
                                                isSubmittingSuccess ?
                                                    <div>
                                                        
                                                        <div className="alert alert-success d-flex align-items-center fs-6" role="alert">
                                                            <i className="bi bi-check-circle pe-1"></i>
                                                            <div>Submitted Successfully!</div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                        {/* <button type="button" onClick={() => saveReview()} hidden={scorecardCtx.isReviewSubmitted ? true : false} className={`btn btn-primary me-3`}>Save</button> */}
                                                        <button type="button" onClick={() => submitReview()} className={`btn btn-primary ${styles.updateScore}`}>Update</button>
                                                    </>
                                            )
                                    )
                                }
                            </div>
                        </> :
                        null
                }
            </div>            
            <div className={styles.scoreCardQuestionsContainer}>
                {
                    isContextLoaded ?
                        <div className="bg-transparent border-0 mb-3">
                            <div className="p-3">
                                <ul className="list-unstyled m-0">
                                    <Questions
                                        // score={score}
                                        // sectionUUID={uuid}
                                        sectionIndex={0}
                                        questions={scorecardCtx?.customerEffortAssesment?.sections[0]?.questions}
                                    />
                                </ul>
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
}

export default CustomeEffortAssesment
